import { DateTimeView } from '@components/organisms/date-time-view/date-time-view';
import type { DateTimeOptions } from '@components/organisms/date-time-view/date-time-view.types';
import type { CellContext } from '@tanstack/react-table';
import type { DataGridColumnDef, DataGridColumnDefOptions } from '../../data-grid.type';

export function getColumnDefDateTime<T>(col: DataGridColumnDef<T>, options: DataGridColumnDefOptions) {
	return function DateTimeCell(context: CellContext<T, unknown>) {
		const value = context.getValue() as string | number | Date;
		const dateTimeOptions = col.options as DateTimeOptions | undefined;
		const row = context.row.original;

		const timezone = dateTimeOptions?.timezone ?? options.timezone;
		const locale = dateTimeOptions?.locale ?? options.locale;
		const parsedContent = options?.parse?.(value, row, options);

		return (
			<DateTimeView
				date={value}
				timezone={timezone}
				locale={locale}
				dateStyle={dateTimeOptions?.dateStyle}
				timeStyle={dateTimeOptions?.timeStyle}
				parsedContent={parsedContent}
			/>
		);
	};
}
